import { useTranslation } from '@gimlite/common';
import {
  Timeline,
  TimelineType,
} from '../../components/timeline/timeline.component';

export declare namespace EntryDeniedSessionTimelineType {
  type Props = {
    data: {
      date: TimelineType.Data.Date;
      extra: TimelineType.Data.Extra;
      device: TimelineType.Data.Device;
      subtitle: TimelineType.Data.SubTitle;
    };
  };
}

export const EntryDeniedSessionTimeline = ({
  data: { date, extra, device, subtitle },
}: EntryDeniedSessionTimelineType.Props) => {
  const { t } = useTranslation();
  return (
    <Timeline
      config={{
        color: 'error',
      }}
      data={{
        icon: 'faCarSolid',
        date,
        device,
        title: t('global-state-entry-denied'),
        extra,
        subtitle: t(`global-reason-${subtitle}`),
      }}
    />
  );
};
